<svg class="w-100" viewBox="0 0 464 80">
    <path
        class="appliance"
        d="M64.4 0C68.5 0 71.9 3.3 72 7.3L72 7.6 72 72.4C72
        76.5 68.7 79.9 64.7 80L64.4 80 15.6 80C11.5 80 8.1 76.7
        8 72.7L8 72.4 8 7.6C8 3.5 11.3 0.1 15.3 0L15.6 0 64.4
        0ZM68 28L12 28 12 72.4C12 74.3 13.5 75.9 15.4 76L15.6
        76 64.4 76C66.3 76 67.9 74.5 68 72.6L68 72.4 68 28ZM51
        32C52.1 32 53 32.9 53 34 53 35.1 52.2 35.9 51.1 36L51
        36 29 36C27.9 36 27 35.1 27 34 27 32.9 27.8 32.1 28.9
        32L29 32 51 32ZM64.4 4L15.6 4C13.7 4 12.1 5.5 12 7.4L12
        7.6 12 24 68 24 68 7.6C68 5.7 66.5 4.1 64.6 4L64.4
        4ZM23.1 11.9C24.3 13.1 24.3 14.9 23.1 16.1 21.9 17.3
        20.1 17.3 18.9 16.1 17.7 14.9 17.7 13.1 18.9 11.9 20.1
        10.7 21.9 10.7 23.1 11.9ZM61.1 11.9C62.3 13.1 62.3 14.9
        61.1 16.1 59.9 17.3 58.1 17.3 56.9 16.1 55.7 14.9 55.7
        13.1 56.9 11.9 58.1 10.7 59.9 10.7 61.1 11.9ZM49.1
        11.9C50.3 13.1 50.3 14.9 49.1 16.1 47.9 17.3 46.1 17.3
        44.9 16.1 43.7 14.9 43.7 13.1 44.9 11.9 46.1 10.7 47.9
        10.7 49.1 11.9Z" />
    <path
        class="appliance"
        d="M160.4 0C164.5 0 167.9 3.3 168 7.3L168 7.6 168
        72.4C168 76.5 164.7 79.9 160.7 80L160.4 80 111.6 80C107.5
        80 104.1 76.7 104 72.7L104 72.4 104 7.6C104 3.5 107.3 0.1
        111.3 0L111.6 0 160.4 0ZM164 28L108 28 108 72.4C108 74.3
        109.5 75.9 111.4 76L111.6 76 160.4 76C162.3 76 163.9 74.5
        164 72.6L164 72.4 164 28ZM151.2 36C153.8 36 155.9 38 156
        40.6L156 40.8 156 63.2C156 65.8 154 67.9 151.4 68L151.2 68
        118.8 68C116.2 68 114.1 66 114 63.4L114 63.2 114 40.8C114
        38.2 116 36.1 118.6 36L118.8 36 151.2 36ZM151.2 40L118.8
        40C118.4 40 118.1 40.3 118 40.7L118 40.8 118 63.2C118 63.6
        118.3 63.9 118.7 64L118.8 64 151.2 64C151.6 64 151.9 63.7
        152 63.3L152 63.2 152 40.8C152 40.4 151.7 40.1 151.3
        40L151.2 40ZM160.4 4L111.6 4C109.7 4 108.1 5.5 108 7.4L108
        7.6 108 24 164 24 164 7.6C164 5.7 162.5 4.1 160.6 4L160.4
        4ZM139 11C140.7 11 142 12.3 142 14 142 15.7 140.7 17 139
        17L133 17C131.3 17 130 15.7 130 14 130 12.3 131.3 11 133
        11L139 11ZM119.1 11.9C120.3 13.1 120.3 14.9 119.1 16.1
        117.9 17.3 116.1 17.3 114.9 16.1 113.7 14.9 113.7 13.1
        114.9 11.9 116.1 10.7 117.9 10.7 119.1 11.9ZM157.1
        11.9C158.3 13.1 158.3 14.9 157.1 16.1 155.9 17.3 154.1 17.3
        152.9 16.1 151.7 14.9 151.7 13.1 152.9 11.9 154.1 10.7
        155.9 10.7 157.1 11.9Z" />
    <path
        class="appliance"
        d="M256.4 0C260.5 0 263.9 3.3 264 7.3L264 7.6 264
        72.4C264 76.5 260.7 79.9 256.7 80L256.4 80 207.6 80C203.5
        80 200.1 76.7 200 72.7L200 72.4 200 7.6C200 3.5 203.3 0.1
        207.3 0L207.6 0 256.4 0ZM260 28L204 28 204 72.4C204 74.3
        205.5 75.9 207.4 76L207.6 76 256.4 76C258.3 76 259.9 74.5
        260 72.6L260 72.4 260 28ZM232 34C241.4 34 249 41.6 249 51
        249 60.4 241.4 68 232 68 222.6 68 215 60.4 215 51 215 41.6
        222.6 34 232 34ZM228.8 49C225.5 49 222.2 50.2 219.1 52.6
        219.9 59 225.4 64 232 64 237.8 64 242.7 60.2 244.4 55 240.9
        56.3 237.7 57 234.9 57 233 57 231.6 56.2 230.9 54.7 230.6
        54 230.4 53.4 230.4 52.4L230.3 51.9 230.3 50.7 230.2 50.4
        230.2 50.1C230.1 49.4 230 49.1 229.5 49L229.3 49 229.1 49
        228.8 49ZM232 38C226 38 221 42.1 219.5 47.6 222.4 45.9
        225.6 45 228.8 45 232.6 45 234 46.9 234.2 50.4L234.3 50.9
        234.3 52.2 234.3 52.4 234.4 52.6 234.4 52.7C234.4 52.9
        234.5 52.9 234.6 53L234.6 53 234.7 53 234.9 53C237.7 53
        241.1 52.2 245 50.5 244.7 43.5 239 38 232 38ZM256.4 4L220 4
        220 24 260 24 260 7.6C260 5.7 258.6 4.2 256.8 4L256.6 4
        256.4 4ZM216 4L207.6 4C205.7 4 204.1 5.5 204 7.4L204 7.6
        204 24 216 24 216 4ZM253.1 11.9C254.3 13.1 254.3 14.9 253.1
        16.1 251.9 17.3 250.1 17.3 248.9 16.1 247.7 14.9 247.7 13.1
        248.9 11.9 250.1 10.7 251.9 10.7 253.1 11.9ZM241.1
        11.9C242.3 13.1 242.3 14.9 241.1 16.1 239.9 17.3 238.1 17.3
        236.9 16.1 235.7 14.9 235.7 13.1 236.9 11.9 238.1 10.7
        239.9 10.7 241.1 11.9Z" />
    <path
        class="missing"
        d="M352.4 0C356.5 0 359.9 3.3 360 7.3L360 7.6 360
        72.4C360 76.5 356.7 79.9 352.7 80L352.4 80 303.6 80C299.5
        80 296.1 76.7 296 72.7L296 72.4 296 7.6C296 3.5 299.3 0.1
        303.3 0L303.6 0 352.4 0ZM352.4 4L303.6 4C301.7 4 300.1 5.5
        300 7.4L300 7.6 300 72.4C300 74.3 301.5 75.9 303.4 76L303.6
        76 352.4 76C354.3 76 355.9 74.5 356 72.6L356 72.4 356
        7.6C356 5.7 354.5 4.1 352.6 4L352.4 4ZM328 48C329.1 48 330
        48.9 330 50 330 51.1 329.2 51.9 328.2 52L328 52C326.9 52
        326 51.1 326 50 326 48.9 326.8 48.1 327.9 48L328 48ZM329.2
        28.1C333 28.8 335.8 32.1 335.8 36 335.8 38.6 334.3 40.6
        331.9 42.2 330.7 43 329.4 43.6 328.5 43.9 327.4 44.2 326.3
        43.7 325.9 42.6 325.6 41.6 326.1 40.6 327.1 40.2L327.4 40
        327.7 39.9 328 39.8C328.6 39.5 329.2 39.2 329.7 38.8 331.1
        37.9 331.8 36.9 331.8 36 331.8 34 330.4 32.4 328.5 32 326.7
        31.7 324.8 32.7 324.1 34.5L324.1 34.7C323.7 35.7 322.6 36.3
        321.5 35.9 320.5 35.5 319.9 34.4 320.3 33.3 321.6 29.7
        325.3 27.4 329.2 28.1Z" />
    <path
        class="appliance"
        d="M448.4 0C452.5 0 455.9 3.3 456 7.3L456 7.6 456
        72.4C456 76.5 452.7 79.9 448.7 80L448.4 80 399.6 80C395.5
        80 392.1 76.7 392 72.7L392 72.4 392 7.6C392 3.5 395.3 0.1
        399.3 0L399.6 0 448.4 0ZM452 28L396 28 396 72.4C396 74.3
        397.5 75.9 399.4 76L399.6 76 448.4 76C450.3 76 451.9 74.5
        452 72.6L452 72.4 452 28ZM424 34C433.4 34 441 41.6 441 51
        441 60.4 433.4 68 424 68 414.6 68 407 60.4 407 51 407 41.6
        414.6 34 424 34ZM424 38C416.8 38 411 43.8 411 51 411 58.2
        416.8 64 424 64 431.2 64 437 58.2 437 51 437 43.8 431.2 38
        424 38ZM448.4 4L412 4 412 24 452 24 452 7.6C452 5.7 450.6
        4.2 448.8 4L448.6 4 448.4 4ZM408 4L399.6 4C397.7 4 396.1
        5.5 396 7.4L396 7.6 396 24 408 24 408 4ZM445.1 11.9C446.3
        13.1 446.3 14.9 445.1 16.1 443.9 17.3 442.1 17.3 440.9 16.1
        439.7 14.9 439.7 13.1 440.9 11.9 442.1 10.7 443.9 10.7
        445.1 11.9ZM433.1 11.9C434.3 13.1 434.3 14.9 433.1 16.1
        431.9 17.3 430.1 17.3 428.9 16.1 427.7 14.9 427.7 13.1
        428.9 11.9 430.1 10.7 431.9 10.7 433.1 11.9Z" />
</svg>
